import { usePromo } from '@entities/promo-video';
import type React from 'react';
import { Card } from '@shared/ui';
import * as st from './styles.module.scss';

type Props = {
  videoId: number;
};

export const PromoHead: React.FC<Props> = ({ videoId }) => {
  const { promo } = usePromo(videoId);
  return (
    <Card className={st.head}>
      <div className={st.head__image}>
        <img src={promo?.screenshot_url} />
      </div>

      <div className={st.head__title}>
        <h2>Трейлер</h2>
      </div>
    </Card>
  );
};
